<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`${formInline.license || ''}出车费用明细表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceExpenseSummary",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      getListUrl: 'driverec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/expenseSummary" },
        { name: "出车费用汇总表", path: "/finance/expenseSummary" },
        { name: "费用明细" },
      ],
      formCtrl: [
        {
          label: "加油方式",
          keyName: "gsid",
          placeholder: "请选择加油方式",
          type: "select",
          options: [],
        },
        {
          label: "装货日期",
          keyName: "starttime",
          type: "daterange",
        },
      ],
      cols: [],
      btns: [
        {
          ...this.editBtn,
          cb: ({ orderid }) => {
            this.$router.push(
              `/finance/feedetails?id=${orderid}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['license'],
    };
  },
  methods: {
    setOptions({ gasstation, dayauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'gsid') {
          v.options = gasstation.map(c => {
            return {
              label: c.gasname,
              value: c.id,
            }
          })
        }
      })
      const arr = []
      dayauth.map(v => {
        arr.push({
          prop: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          minwidth: '100px',
        })
      })
      this.cols = [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "starttime", label: "装货日期", minwidth: '110px' },
        { prop: "license", label: "车牌号", minwidth: '110px' },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "infreight", label: "运费", align: 'right', className: 'pr30', width: '100px' },
        ...arr,
        { prop: "doil", label: "现金加油", align: 'right', className: 'pr30', width: '110' },
        { prop: "moneydoil", label: "油气卡加油", align: 'right', className: 'pr30', width: '120' },
        { prop: "gsid", label: "加油方式" },
        { prop: "total", label: "出车合计", align: 'right', className: 'pr30', width: '110' },
      ]
      this.getTotalProperty = [
        'infreight',
        ...arr.map(v => v.prop),
        'doil', 'moneydoil', 'total',
      ]
      this.doLayout()
      this.$forceUpdate()
      // console.log({ ...this.formInline })
    },
  },
  mounted() {
    const { user_group_id, id } = this.user
    if (user_group_id != 1 || id != 1) {
      this.btns[0] = {
        ...this.viewBtn,
        cb: ({ orderid }) => {
          this.$router.push(
            `/finance/feedetails?id=${orderid}&mode=view`
          );
        },
      }
    }
    this.getOptions()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
